
    import { Component, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';

    @Component({
        computed: {
            ...mapState('patient', ['patientData']),
        },
    })
    export default class ImpfempfehlungenTabitem extends Vue {
    }
